import imageUrlBuilder from "@sanity/image-url";
import { sanityClient } from "../../sanity/lib/client";
import { AssetType } from "../../sanity/lib/types/asset";
import { ImageType } from "../../sanity/lib/types/imageAsset";

const builder = imageUrlBuilder(sanityClient);

export const ImageElement = ({
    src,
    alt,
    width = 2560,
    className,
    loading,
    style,
}: {
    src: AssetType | ImageType;
    width?: number;
    alt?: string;
    className?: string;
    loading?: "lazy" | "eager";
    style?: React.CSSProperties;
}) => {
    if (!src.asset?._ref) {
        return;
    }

    return (
        <img
            {...(loading ? { loading } : {})}
            style={style}
            // src={
            //     process.env.NODE_ENV === "development"
            //         ? `https://placehold.co/${width}`
            //         : builder.image(src).width(width).format("webp").url()
            // }
            src={builder.image(src).width(width).format("webp").url()}
            alt={alt || ""}
            className={className}
        />
    );
};
